
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
@Component
export default class Home extends Vue {
  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 20,
    },
    className: "companyProfile",
  });

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Компании",
        disabled: true,
      },
    ];
  }

  headers: any = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },

    {
      text: "Компания",
      value: "caption",
      sortable: true,
    },
    {
      text: "Email",
      value: "email",
      sortable: true,
    },
    {
      text: "Дата создания",
      value: "createDate",
      sortable: true,
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];
}
